module.exports = __webpack_public_path__ + "img/invite.8878e63f.svg";